import React, { useState } from "react";
import styled from "styled-components";

import helpIcon from "../../assets/img/icons/help-icon.svg";

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: ${({ margin }) => margin || "0"};
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  img {
    width: ${({ size }) => size || "16px"};
    height: ${({ size }) => size || "16px"};
  }
`;

const TooltipBox = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  /* left: 50%; */
  transform: translateX(-47.5%);
  background-color: #2c3e50;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
  word-wrap: break-word;
  min-width: 150px;
  max-width: ${({ maxWidth }) => maxWidth || "300px"};
  width: max-content;
  z-index: 1000;
  opacity: ${({ show }) => (show ? "1" : "0")};
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  transition: opacity 0.2s, visibility 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #2c3e50;
  }

  @media (max-width: 768px) {
    max-width: 200px;
    font-size: 11px;
  }
`;

function HelperIcon({ text, size, margin, maxWidth }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <TooltipContainer margin={margin}>
      <IconButton
        size={size}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        type="button"
        aria-label="Help information"
      >
        <img src={helpIcon} alt="help" />
      </IconButton>
      <TooltipBox show={showTooltip} maxWidth={maxWidth}>
        {text}
      </TooltipBox>
    </TooltipContainer>
  );
}

export default HelperIcon;
